import sanitize from 'sanitize-html'

export function sanitizeText( item ) {
  return sanitize(item.replace(/\n|\r\n|\r/g, '<br />'), {
    allowedTags: 'br'
  })
}